<template>
  <!-- <div class="PrestaPush" :class="{ 'PrestaPush_show': isShow, 'PrestaPush_url': data.href }" @click="openLink"> -->
  <div class="PrestaPush" :class="{ 'PrestaPush_show': isShow }">
    <a :href="data.slug">
      <figure class="PrestaPush_figure">
        <img :src="data.image.url"/>
        <h3>{{ data.unique_prestations_title }}</h3>
      </figure>
    </a>
  </div>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'

  export default {
    name: 'PrestaPush',
    props: [ 'data' ],
    mixins: [ scrollUpdate ],
    data() {
      return {
        isShow : false
      }
    },
    methods: {
      onVisible()
      {
        this.isShow  = true
      }
    }
  }
</script>

<style lang="stylus" scoped>
.PrestaPush
  position relative
  height 400px
  max-height 400
  /** grid 2x3 */
  // height 250px
  // max-height 250px
  // width calc((100% - 60px) / 3)
  /** end grid 2x3 */
  /** grid 2x2 */
  width calc((100% - 60px) / 2)
  /** end grid 2x2 */
  overflow hidden
  margin-bottom 60px
  background-color white
  box-shadow 10px 15px 50px rgba(0,0,0,0.1)
  opacity 0
  transition opacity 0.6s 0.3s $ease, transform 1.4s 0.3s $ease
  transform translateY(30%)
  cursor pointer

  @media $medium
    /** grid 2x3 medium */
    // width calc((100% - 30px) / 2)
    // height 100%
    /** end grid 2x3 medium */
    box-shadow 3px 5px 12px rgba(0,0,0,0.15)
    transition-delay 0s

  @media $small
    margin-bottom 30px
    width 100%
    /** grid 2x3 small */
    // max-height 170px
    /** end grid 2x3 small */
    /** grid 2x2 small */
    max-height 300px
    /** end grid 2x2 small */

  &_show
    opacity 1
    transform translateY(0%)

  &_figure
    width 100%
    overflow hidden
    /** grid 2x3 */
    // height 250px
    // max-height 250px
    /** end grid 2x3 */
    /** grid 2x2 */
    height 400px
    max-height 400px
    /** end grid 2x2 */
    margin 0px
    position relative

    &:before
      content ''
      width 100%
      height 100%
      position absolute
      top 0
      left 0
      opacity .1
      z-index 8
      background-color black
      transition opacity 0.6s $ease

    &:hover

      &:before
        opacity .3

    @media $small
      /** grid 2x3 */
      max-height 170px
      /** end grid 2x3 */
      /** grid 2x2 */
      max-height 300px
      /** grid 2x2 */

    img
      width 100%
      min-height 100%
      object-fit cover
      position absolute
      top 50%
      left 50%
      transition transform 0.6s $ease
      transform translate(-50%, -50%)
      z-index 1

    h3
      position relative !important
      z-index 99 !important
      top 50%
      text-align center
      color white
      transform translateY(-50%)
      padding 0 20px
      font-weight 900
</style>
